import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux'
import classnames from 'classnames'
import * as CategoryVisibility from "../../../constants/category/CategoryVisibility"
import {addPrefix} from "../../../utils/UriUtil"
import {jsonResponseHandler} from "../../../utils/FetchHelper"


/**
 * 카테고리 이름, Icon
 * @param props
 * @returns {*}
 * @constructor
 */
function CategoryLabel(props){
  const {visibility, name} = props;

  return <span className="txt_lab">
          {CategoryVisibility.isPrivate(visibility) && <span className="ico_blog ico_secret">비공개</span>}
          <span className="inner_lab">{name}</span>
        </span>
}


function CategoryItem({item, isChildren, onClick}) {
  const categoryId = parseInt(item.id)
  if (categoryId === -3) {
    return null
  }

  const selectedCategoryId = useSelector(state => state.post.condition.category)

  return (
    <li className={classnames({on: (categoryId === parseInt(selectedCategoryId))})}>
      <label className="lab_btn" title={item.name}>
        {isChildren && <span className="ico_blog"/>}
        <CategoryLabel visibility={item.visibility} name={item.name}/>
        <input
          type="button" className="btn_g" value={item.name}
          onClick={(e) => onClick(item)}
        />
      </label>
      {!isChildren && item.children &&
        <ul>
          {item.children.map(sub =>
            <CategoryItem key={sub.id} item={sub} isChildren={true} onClick={onClick}/>
          )}
        </ul>
      }
    </li>
  )
}

export default function PostHeadMoveCategoryPanel({moveCategory}) {
  const [categories, setCategories] = useState([])
  const dispatch = useDispatch()

  function fetchCategory() {
    fetch(addPrefix("/manage/category/simple.json") , {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        setCategories(data.categories)
      })
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  return (
    <div className="scroll_opt">
      <strong className="tit_opt">카테고리 변경</strong>
      <ul className="list_opt">
        {categories.map(item =>
          <CategoryItem
            key={item.id}
            item={item} isChildren={false}
            onClick={moveCategory}
          />
        )}
      </ul>
    </div>
  )
}
